import * as React from 'react';

import {Checkbox} from '../checkbox/checkbox';
import type {Props as CheckboxProps} from '../checkbox/checkbox';

import styles from './conditional-checkbox-input.module.css';

type Props = CheckboxProps & {
    children: React.ReactNode;
    isConditionalAlignedWithLabel?: boolean;
    isLarge?: boolean;
};

/* Responsible for rendering a checkbox component that when enabled
conditionally shows content beneath it, keeping a consistent checkbox
gutter */
export function ConditionalCheckboxInput(props: Props) {
    const {
        children,
        isConditionalAlignedWithLabel = true,
        isLarge = true,
        ...checkboxProps
    } = props;

    return (
        <>
            <Checkbox {...checkboxProps} isLarge={isLarge} />
            {checkboxProps.checked ? (
                <div
                    className={
                        isConditionalAlignedWithLabel
                            ? styles['conditional-container--aligned']
                            : styles['conditional-container']
                    }
                >
                    {children}
                </div>
            ) : undefined}
        </>
    );
}
